module.exports = __webpack_public_path__ + "img/score-box-bg.1f1b0955.png";